export default "__VITE_ASSET__399522ae__"